import map from "lodash/map";

import PropTypes from "prop-types";
import React from "react";
import cx from "classnames";

const PAGES = {
  // Downloads: "/dashboard/support/downloads",
  //  "Articles": "/dashboard/support/articles",
  //"FAQ": "/dashboard/support/faq",
  "Contact Us": "/dashboard/support/contact",
};

function SettingsNav(props, { locals: { pathname } }) {
  return (
    <aside role="secondary-navbar" tabIndex="-1">
      <h6>Support</h6>
      <ul className="Sidebar-Nav nav">
        {map(PAGES, (url, page) => {
          return (
            <li key={page}>
              <a className={cx({ active: url === pathname })} href={url}>
                {page}
              </a>
            </li>
          );
        })}
      </ul>
    </aside>
  );
}

SettingsNav.contextTypes = { locals: PropTypes.object };

export default SettingsNav;
